export default "__VITE_ASSET__C5Rw7hiR__"